import { DOCUMENT_UPLOAD_PAGE } from "../consts";

export const ADD_DOCUMENT_BILL_PAGE = {
  TITLE: "Add document bill",
  ABSOLUTE_PATH: (documentId: string) =>
    `${DOCUMENT_UPLOAD_PAGE.ABSOLUTE_PATH}/${documentId}/add`,
  PATH: ":documentId/add",
  KEY: "documentId",
} as const;
